import { ODataSelect } from "../../../../../Providers.Api/ODataQuery";

export class storeDetails extends ODataSelect
{
    public Node_Id = 0;
    public Space_Id = "";
    public Space_Name = "";
    public Space_Type = "";
    public Space_IsEnabled = 0;
    public Space_Custom_Info = "";
}

export class AssignedSpace extends ODataSelect
{
    public Node_Id = 0;
    public Space_Id = "";
    public Space_Name = "";
    public Space_Type = "";
    public Meta_Loc_Zone = "";
    public Space_IsEnabled = 0;
}

export interface ISpace
{
    nodeId: number;
    spaceId: string;
    spaceType: string;
    spaceName: string;
    metaLocZone: string;
}